var jwtDecode = require('jwt-decode').default;
var fp = require('lodash/fp');
var SOCIAL_KID = 'social';
var SIGN_ON_TYPE = {
  COGNITO: 'cognito',
  SOCIAL: 'social'
};
var determineIssuer = function determineIssuer(_ref) {
  var bearerToken = _ref.bearerToken;
  var header = jwtDecode(bearerToken, {
    header: true
  });
  var kid = fp.get('kid', header);
  switch (kid) {
    case SOCIAL_KID:
      return SIGN_ON_TYPE.SOCIAL;
    default:
      return SIGN_ON_TYPE.COGNITO;
  }
};
var decodeToken = function decodeToken(_ref2) {
  var bearerToken = _ref2.bearerToken;
  return jwtDecode(bearerToken);
};
var isSocialToken = function isSocialToken(_ref3) {
  var bearerToken = _ref3.bearerToken;
  return determineIssuer({
    bearerToken: bearerToken
  }) === SIGN_ON_TYPE.SOCIAL;
};
module.exports = {
  SOCIAL_KID: SOCIAL_KID,
  SIGN_ON_TYPE: SIGN_ON_TYPE,
  determineIssuer: determineIssuer,
  isSocialToken: isSocialToken,
  decodeToken: decodeToken
};